// extracted by mini-css-extract-plugin
export default {"cognitive_table":"CognitiveTable_cognitive_table__gbW1V","accession_label":"CognitiveTable_accession_label__-yJI5"};